"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var constants_1 = __importDefault(require("./constants"));
// Components
var ModalFooter_1 = __importDefault(require("./components/ModalFooter"));
var ModalHeader_1 = __importDefault(require("./components/ModalHeader"));
var TabItemWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ",
    "\n"])), function (props) {
    return props.isEmpty &&
        "\n  &::after {\n    position: absolute;\n    content: '';\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    margin-left: " + props.theme.space.xs + "px;\n    background-color: " + props.theme.colors.red.haptik + ";\n  }";
});
var TabsWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    padding: 0,
    overflowX: 'auto',
    width: '100%',
    fontSize: props.theme.fontSizes[2],
    fontWeight: props.theme.fontWeights.semiBold,
    borderRadius: props.theme.radii.lg,
    border: "1px solid " + props.theme.colors.grey.haptik,
    marginTop: props.theme.space.sm,
}); });
var TextInputWrapper = styled_components_1["default"](text_2["default"])(function (props) { return ({
    marginTop: props.theme.space.sm,
}); });
// initial state
var initialState = {
    editedDisambiguationData: {},
    currentLanguage: '',
    currentLanguageScripts: [],
    supportedLanguages: [],
};
function reducer(state, action) {
    switch (action.type) {
        case constants_1["default"].ActionTypes.UPDATE_EDITED_DISAMBIGUATION_DATA:
            return __assign(__assign({}, state), { editedDisambiguationData: action.data });
        case constants_1["default"].ActionTypes.UPDATE_CURRENT_LANGUAGE:
            return __assign(__assign({}, state), { currentLanguage: action.data });
        case constants_1["default"].ActionTypes.UPDATE_CURRENT_LANGUAGE_SCRIPTS:
            return __assign(__assign({}, state), { currentLanguageScripts: action.data });
        case constants_1["default"].ActionTypes.SET_SUPPORTED_LANGUAGES:
            return __assign(__assign({}, state), { supportedLanguages: action.data });
        default:
            return state;
    }
}
var DisambiguationModal = function (_a) {
    var _b;
    var isActive = _a.isActive, isLoading = _a.isLoading, onClose = _a.onClose, onSave = _a.onSave, disambiguationData = _a.disambiguationData, languagesCodeToTitle = _a.languagesCodeToTitle;
    var _c = react_1.useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var editedDisambiguationData = state.editedDisambiguationData, currentLanguage = state.currentLanguage, currentLanguageScripts = state.currentLanguageScripts, supportedLanguages = state.supportedLanguages;
    var defaultText = (_b = disambiguationData === null || disambiguationData === void 0 ? void 0 : disambiguationData[MogamboConstants_1.DEFAULT_LANGUAGE]) === null || _b === void 0 ? void 0 : _b[MogamboConstants_1.DEFAULT_LANGUAGE];
    var canSave = Object.keys(editedDisambiguationData).length > 0; // If edited data is there
    // Updates the editedDisambiguationData
    var updateEditedData = function (value) {
        dispatch({
            type: constants_1["default"].ActionTypes.UPDATE_EDITED_DISAMBIGUATION_DATA,
            data: value,
        });
    };
    var saveData = function () {
        onSave(editedDisambiguationData, function () {
            updateEditedData({});
        });
    };
    // Returns true when the editedDisambiguationData has some empty text in the languages
    var hasEmptyLanguage = react_1.useCallback(function () {
        // if the languages are having language scripts as well, then
        // traverse all the values of language scripts.
        return Boolean(Object.keys(editedDisambiguationData).filter(function (language) {
            return Object.values(editedDisambiguationData[language]).filter(function (value) { return !value.trim(); }).length;
        }).length);
    }, [editedDisambiguationData, disambiguationData]);
    react_1.useEffect(function () {
        // Supported Languages Except English
        var languages = Object.keys(disambiguationData).filter(function (key) { return key !== MogamboConstants_1.DEFAULT_LANGUAGE; });
        dispatch({
            type: constants_1["default"].ActionTypes.SET_SUPPORTED_LANGUAGES,
            data: languages,
        });
        if (!currentLanguage)
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_CURRENT_LANGUAGE,
                data: languages === null || languages === void 0 ? void 0 : languages[0],
            });
        // To check empty text language in disambiguationData
        Object.keys(disambiguationData).forEach(function (language) {
            Object.values(disambiguationData[language]).map(function (value) {
                var _a;
                if (!value) {
                    updateEditedData(__assign(__assign({}, editedDisambiguationData), (_a = {}, _a[language] = '', _a)));
                }
            });
        });
    }, [disambiguationData]);
    react_1.useEffect(function () {
        // To set language scripts of currently selected language
        if (currentLanguage && Object.keys(disambiguationData).length) {
            dispatch({
                type: constants_1["default"].ActionTypes.UPDATE_CURRENT_LANGUAGE_SCRIPTS,
                data: Object.keys(disambiguationData[currentLanguage]) || [],
            });
        }
    }, [currentLanguage]);
    var onTextInputChange = function (value, languageScript) {
        var _a, _b;
        var currentFieldValue = disambiguationData[currentLanguage][languageScript];
        // If the current changed value is not equal to the existing value
        if (value !== currentFieldValue) {
            var currentLanguageValue = __assign(__assign({}, editedDisambiguationData[currentLanguage]), (_a = {}, _a[languageScript] = value, _a));
            updateEditedData(__assign(__assign({}, editedDisambiguationData), (_b = {}, _b[currentLanguage] = currentLanguageValue, _b)));
        }
        else {
            /**
             * If the edited and original value is same,
             * then remove it from editedData if it is present.
             */
            var editedDataObj = __assign({}, editedDisambiguationData);
            // Handle case when language data has multiple scripts as well.
            // First condition is to check whether editedDataObj[currentLanguage] is a Object or not.
            if (editedDataObj[currentLanguage] ===
                Object(editedDataObj[currentLanguage]) &&
                Object.keys(editedDataObj[currentLanguage]).length > 1)
                delete editedDataObj[currentLanguage][languageScript];
            else
                delete editedDataObj[currentLanguage];
            updateEditedData(editedDataObj);
        }
    };
    // Renders the Tabs for Supported Languages
    var renderTabs = function () {
        return (react_1["default"].createElement(tabs_1["default"], { themed: true, value: currentLanguage }, supportedLanguages.map(function (language) {
            var _a, _b;
            return (react_1["default"].createElement(tabs_1["default"].Item, { key: language, value: language, onClick: function () {
                    dispatch({
                        type: constants_1["default"].ActionTypes.UPDATE_CURRENT_LANGUAGE,
                        data: language,
                    });
                } },
                react_1["default"].createElement(TabItemWrapper, { isEmpty: editedDisambiguationData[language] && ((_b = (_a = Object.values(editedDisambiguationData[language])) === null || _a === void 0 ? void 0 : _a.filter(function (value) { return !value.trim(); })) === null || _b === void 0 ? void 0 : _b.length) }, languagesCodeToTitle[language] || language)));
        })));
    };
    var renderTextInputs = function () {
        return (react_1["default"].createElement(react_1["default"].Fragment, null, currentLanguageScripts.map(function (languageScript) {
            var _a;
            return (react_1["default"].createElement(TextInputWrapper, { themed: true, value: ((_a = editedDisambiguationData[currentLanguage]) === null || _a === void 0 ? void 0 : _a[languageScript]) !==
                    undefined
                    ? editedDisambiguationData[currentLanguage][languageScript]
                    : disambiguationData[currentLanguage][languageScript], placeholder: "Enter " + (languagesCodeToTitle[languageScript + "|" + currentLanguage] ||
                    languagesCodeToTitle[currentLanguage] ||
                    currentLanguage) + " text here.", onChange: function (value) { return onTextInputChange(value, languageScript); } }));
        })));
    };
    if (!Object.keys(disambiguationData).length && !isLoading)
        return null;
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: isActive, onClose: onClose, header: react_1["default"].createElement(ModalHeader_1["default"], null), footer: react_1["default"].createElement(ModalFooter_1["default"], { showTooltip: canSave && hasEmptyLanguage(), isButtonDisabled: !canSave || hasEmptyLanguage(), onSave: saveData }) },
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", overflowX: "hidden", width: "573px" }, isLoading ? (react_1["default"].createElement(loader_1["default"], { themed: true })) : (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column" },
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "*Did you mean button text"),
                react_1["default"].createElement(TextInputWrapper, { themed: true, disabled: true, value: defaultText })),
            supportedLanguages.length !== 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(box_1["default"], { padding: "0", margin: "24px 0px", flexDirection: "column" },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Select Language"),
                    react_1["default"].createElement(TabsWrapper, null, renderTabs())),
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column" },
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "*Translated Text"),
                    renderTextInputs()))))))));
};
exports["default"] = DisambiguationModal;
var templateObject_1;
